import { useState, useEffect, useContext } from "react";
import { AppContext } from "../App";
import { 
  BsFillSuitDiamondFill,
  BsFillSuitHeartFill,
  BsSuitClubFill,
  BsFillSuitSpadeFill,
} from 'react-icons/bs'
import { GameContext as ArubastiniContext } from '../boards/ArubastiniBoard';
import { GameContext as LastcardContext } from "../boards/LastcardBoard";
import { GAME_TYPES } from "../Constants";
import Lastcard from "../models/Lastcard";
import MobileInterface from "../../MobileInterface";

export default function UserCard(props) {
  const app = useContext(AppContext);
  const arubastini = useContext(ArubastiniContext);
  const lastcard = useContext(LastcardContext);

  const gameContext = arubastini || lastcard;

  const [ data, setData ] = useState(props.data);
  const [ selected, setSelected ] = useState(false);

  useEffect(() => {
    setData(props.data);
  }, [ props.data ])

  useEffect(() => {
    if(gameContext.selectedCard) {
      if(data.index === gameContext.selectedCard) {
        setSelected(true);
      } else {
        setSelected(false);
      }
    } else {
      setSelected(false);
    }
    

  }, [ gameContext.selectedCard ]);

  useEffect(() => {
    if(gameContext.selectedCards) {
      if(gameContext.selectedCards.indexOf(data.index) > -1) {
        setSelected(true);
      } else {
        setSelected(false);
      }
    } else {
      setSelected(false);
    }
  }, [ gameContext.selectedCards ])

  function clicked() {
    if(!gameContext.boardLocked) {
      if(app.gameData.type === GAME_TYPES.ARUBASTINI) {
        //logic for arubastini
        if(app.gameData.currentPlayer === Number(app.userId)) {
          //haptic
          MobileInterface.playSound('vibrate1');

          gameContext.setSelectedCard(data.index);
          gameContext.setError(false);
        } else {
          gameContext.setError("Not your turn to play, please wait..");
        }
      } else if(app.gameData.type === GAME_TYPES.LASTCARD) {
        //logic for lastcard
        if(app.gameData.currentPlayer === Number(app.userId)) {
          //...
          if(!selected) {
            const isSelectionValid = Lastcard.isSelectionValid({
              selectedCard: data.index,
              allSelectedCards: gameContext.selectedCards,
              gameData: app.gameData,
            })
    
            if(isSelectionValid) {
              //haptic
              MobileInterface.playSound('vibrate1');

              gameContext.setSelectedCards(prevCards => {
                if(prevCards && prevCards.length > 0) {
                  return [...prevCards, data.index];
                } else {
                  return [data.index];
                }
              })
              gameContext.setError(false);
            } else {
              gameContext.setError("Invalid card selected");
            }
          } else {
            //handle unselect
            gameContext.resetSelections();
            gameContext.setError(false);
          }
          //...
        } else {
          gameContext.setError("Not your turn to play, please wait..");
        }
        
      }
    } else {
      gameContext.setError("Syncing, please wait...");
    }
  }

  return (
    <div 
      className="coreOneUserCard"
      data-symbol={data.symbol}
      onClick={clicked}
      data-selected={selected}
    >
      <span className="mChar1">{data.character}</span>
      <span className="mChar2">{data.character}</span>
      {
        (data.symbol === 'kisu') ?
        <>
          <BsFillSuitDiamondFill
            className="mSymbol1"
          />
          <BsFillSuitDiamondFill
            className="mSymbol2"
          />
          <BsFillSuitDiamondFill
            className="mSymbolMid"
          />
        </>
        :null
      }
      
      {
        (data.symbol === 'kopa') ?
        <>
          <BsFillSuitHeartFill
            className="mSymbol1"
          />
          <BsFillSuitHeartFill
            className="mSymbol2"
          />
          <BsFillSuitHeartFill
            className="mSymbolMid"
          />
        </>
        :null
      }

      {
        (data.symbol === 'jembe') ?
        <>
          <BsFillSuitSpadeFill
            className="mSymbol1"
          />
          <BsFillSuitSpadeFill
            className="mSymbol2"
          />
          <BsFillSuitSpadeFill
            className="mSymbolMid"
          />
        </>
        :null
      }

      {
        (data.symbol === 'karanga') ?
        <>
          <BsSuitClubFill
            className="mSymbol1"
          />
          <BsSuitClubFill
            className="mSymbol2"
          />
          <BsSuitClubFill
            className="mSymbolMid"
          />
        </>
        :null
      }
    </div>
  )
}